// Keycloak Configuration
export const keycloakConfig = {
  url: import.meta.env.VITE_KEYCLOAK_URL || 'https://idp.kbw.de',
  realm: import.meta.env.VITE_KEYCLOAK_REALM || 'kbw',
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'portal-frontend',
};

// API Configuration
export const apiConfig = {
  baseUrl: import.meta.env.VITE_API_BASE_URL || 'https://portal.kbw.de/api',
};

// Direct Access Grant Configuration
export const directGrantConfig = {
  tokenEndpoint: `${keycloakConfig.url}/realms/${keycloakConfig.realm}/protocol/openid-connect/token`,
  userInfoEndpoint: `${keycloakConfig.url}/realms/${keycloakConfig.realm}/protocol/openid-connect/userinfo`,
  logoutEndpoint: `${keycloakConfig.url}/realms/${keycloakConfig.realm}/protocol/openid-connect/logout`,
};

// Role Configuration
export const roleConfig = {
  // Interne Benutzer-Rolle (aus LDAP/Keycloak)
  internalRole: import.meta.env.VITE_INTERNAL_ROLE || 'User_Allgemein',
  
  // Weitere Rollen für erweiterte Berechtigungen
  adminRole: import.meta.env.VITE_ADMIN_ROLE || 'admin',
  dozentRole: import.meta.env.VITE_DOZENT_ROLE || 'dozent',
  mitarbeiterRole: import.meta.env.VITE_MITARBEITER_ROLE || 'mitarbeiter',
};
